export default {
  boxes: [],
  loading: false,
}